import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import ConditionalWrapper from 'utils/ConditionalWrapper'
import CustomFormCheck from 'utils/CustomFormCheck';

class ManageSubsByUser extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      subscribedUsers: this.props.subscribed_users,
      checked: this.props.subscribed_users.includes(this.props.selectedUser)
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedUser !== this.props.selectedUser) {
      this.setState({checked: this.state.subscribedUsers.includes(this.props.selectedUser)});
    }
  }

  removeUser() {
    this.setState({ checked: false });
    this.props.removeUser(this.props.selectedUser, this.props.section_name, this.props.section_id);
    let subscribedUsers = [...this.state.subscribedUsers];
    subscribedUsers.splice(subscribedUsers.findIndex((e) => { return e == this.props.selectedUser }), 1);
    this.setState({subscribedUsers: subscribedUsers});
  }

  addUser() {
    this.setState({ checked: true });
    this.props.addUser(this.props.selectedUser, this.props.section_name, this.props.section_id);
    let subscribedUsers = [...this.state.subscribedUsers];
    subscribedUsers.push(this.props.selectedUser);
    this.setState({subscribedUsers: subscribedUsers});
  }

  render() {
    return (
      <React.Fragment>
        <ConditionalWrapper
          condition={!this.props.section_id}
          wrapper={
            children => (
              <>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>This service is disabled</Tooltip>}
                >
                  {children}
                </OverlayTrigger>
              </>
            )
          }
        >
          <div>
            <CustomFormCheck disabled={this.props.section_id == null ? true : false} id={`${this.props.section_name}-${this.props.section_id}`} checked={this.state.checked} onChange={this.state.checked ? (e) => this.removeUser(e) : (e) => this.addUser(e)} />
          </div>
        </ConditionalWrapper>
      </React.Fragment>
    )
  }
}

export default ManageSubsByUser;
